module.exports = __webpack_public_path__ + "img/528.5e70bbe9.jpg";